/** Dimensions declared in pixels because Next Image / JS don't support rem */

// Largest size (on a mobile device)
export const CARD_LIST_THUMBNAIL_MAX_WIDTH = 400
// Largest size (on a mobile device)
export const LARGE_CARD_LIST_THUMBNAIL_MAX_WIDTH = 720
// Fixed size across all devices/viewport widths
// E.g. mini trackrow
export const ALBUM_ARTWORK_XS = 56
// E.g. track row, track tray
export const ALBUM_ARTWORK_S = 144
// E.g. album/playlist card
export const ALBUM_ARTWORK_M = 200
// E.g. collection card, album list card
export const ALBUM_ARTWORK_L = 480
// Maximum width of any hero image
export const HERO_IMAGE_WIDTH = 2504
